<template>
    <t-layout style="height: 100vh;">
        <div style="border-bottom: solid 1px #a6a6a6;">
        <t-header>
            <t-head-menu value="item1" height="120px">
                <template #logo>
                    <img width="50" class="logo" src="../assets/logo.png" alt="logo" />
                </template>
                <template #operations>
                    <a href="javascript:;"><t-icon class="t-menu__operations-icon" name="search" /></a>
                    <a href="javascript:;"><t-icon class="t-menu__operations-icon" name="notification-filled" /></a>
                    <t-tooltip content="回到首页">
                        <a  @click="()=>{router.push('/home/index')}"><t-icon class="t-menu__operations-icon" name="home" /></a>
                    </t-tooltip>
                </template>
            </t-head-menu>
        </t-header>
        </div>
        <t-layout style="height: 100%;">
            <t-aside style="border-top: 1px solid var(--component-border)">
                <t-menu theme="light" :value="menu_value" @change="menu_change_handler" style="margin-right: 50px" height="550px">
                    <t-menu-item value="0">
                        <template #icon>
                            <t-icon name="app" />
                        </template>
                        首页
                    </t-menu-item>
                    <t-menu-item value="9">
                        <template #icon>
                            <t-icon name="filter-2" />
                        </template>
                        AI助手
                    </t-menu-item>
                    <t-submenu value="1" title="采购管理">
                        <template #icon>
                            <t-icon name="task-1" />
                        </template>
                        <t-menu-item value="1-1"> 询价单管理 </t-menu-item>
                        <t-menu-item value="1-2"> 采购入库单管理 </t-menu-item>
                        <t-menu-item value="1-3"> 采购订单管理 </t-menu-item>
                        <t-menu-item value="1-4"> 采购退货单管理 </t-menu-item>
                        <t-menu-item value="1-5"> 采购换货单管理 </t-menu-item>
                        <t-menu-item value="1-6"> 采购统计 </t-menu-item>
                    </t-submenu>
                    <t-submenu value="2" title="销售管理">
                        <template #icon>
                            <t-icon name="saving-pot" />
                        </template>
                        <t-menu-item value="2-1"> 销售报价单</t-menu-item>
                        <t-menu-item value="2-2"> 销售订单</t-menu-item>
                        <t-menu-item value="2-3"> 销售出库单</t-menu-item>
                        <t-menu-item value="2-4"> 销售换货单</t-menu-item>
                        <t-menu-item value="2-5"> 销售退货单</t-menu-item>
                    </t-submenu>
                    <t-submenu value="3" title="库存管理">
                        <template #icon>
                            <t-icon name="system-coordinate" />
                        </template>
                        <t-menu-item value="3-1"> 仓库管理</t-menu-item>
                        <t-menu-item value="3-2"> 库存盘点</t-menu-item>
                        <t-menu-item value="3-3"> 库存查看</t-menu-item>
                        <t-menu-item value="3-4"> 其他入库</t-menu-item>
                        <t-menu-item value="3-5"> 其他出库</t-menu-item>
                        <!-- <t-menu-item value="3-6"> 库存调拨</t-menu-item> -->
                        <!-- <t-menu-item value="3-4"> 设置打印模版</t-menu-item> -->
                        <!-- <t-menu-item value="3-4"> 库存调拨</t-menu-item> -->
                    </t-submenu>
                    <!-- <t-submenu value="7" title="财务管理">
                        <template #icon>
                            <t-icon name="wealth" />
                        </template>
                    </t-submenu> -->
                    <t-menu-item value="4" title="员工管理">
                        <template #icon>
                            <t-icon name="dashboard" />
                        </template>
                        员工管理
                    </t-menu-item>
                    <t-menu-item value="5">
                        <template #icon>
                            <t-icon name="user-1" />
                        </template>
                        个人中心
                    </t-menu-item>
                    <t-menu-item value="8">
                        <template #icon>
                            <t-icon name="usergroup" />
                        </template>
                        供应商/客户管理
                    </t-menu-item>
                    <t-menu-item value="6">
                        <template #icon>
                            <t-icon name="setting" />
                        </template>
                        设置
                    </t-menu-item>
                    <t-menu-item value="7">
                        <template #icon>
                            <t-icon name="setting" />
                        </template>
                        打印设置
                    </t-menu-item>

                </t-menu>
            </t-aside>
            
            <t-layout>
                <t-content>
                    <router-view></router-view>
                </t-content>
                <!-- <t-footer>Copyright @ 2019-{{ new Date().getFullYear() }} Tencent. All Rights Reserved</t-footer> -->
            </t-layout>
        </t-layout>
    </t-layout>
</template>

<script setup>
import router from '@/router/main';
import { ref,onMounted } from 'vue'
const menu_value = ref('')
const menu_change_handler = (value) => {
    menu_value.value = value
    if(value === '0') {
        router.push('/home/index')
    }else if(value === '1-1') {
        router.push('/home/inquire')
    }else if(value == '1-2'){
        router.push('/home/purchase_input_warehouse')
    }else if(value == '1-3') {
        router.push('/home/purchase_order')
    }else if(value == '1-4') {
        router.push('/home/purchase_return')
    }else if(value == '1-5') {
        router.push('/home/purchase_replacement')
    }else if(value == '1-6'){
        router.push('/home/purchase_statistics')
    }else if(value == '2-1'){
        router.push('/home/sell_quoted_price')
    }else if (value == '2-2'){
        router.push('/home/sell_order')
    }else if (value == '2-3'){
        router.push('/home/sell_output_warehouse')
    }else if (value == '2-4'){
        router.push('/home/sell_replace')
    }else if (value == '2-5'){
        router.push('/home/sell_return')
    }else if (value == '3-1'){
        router.push('/home/warehouse_mange')
    }else if( value == '3-2'){
        router.push('/home/warehouse_check')
    }else if( value == '3-3' ){
        router.push("/home/warehouse_storge")
    }else if( value == '3-4'){
        router.push('/home/other_input')
    }else if( value == '3-5'){
        router.push('/home/other_output')
    }else if( value == '3-6'){
        router.push('/home/transform_warehouse')
    }else if(value == '4'){
        router.push('/home/staff_manager')
    }else if(value == '5'){
        router.push('/home/person_center')
    }else if(value == '6') {
        router.push('/home/setting')
    }else if(value == '7'){
        router.push('/home/print')
    }else if(value == '8') {
        router.push('/home/cooperative_partner')
    }else if(value == '9') {
        router.push('/home/ai_chat')
    }
}

onMounted(()=>{
    menu_change_handler('0')
})
</script>


<style scoped>

</style>